import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export const FinalCTA = () => {
  return <section className="py-12 md:py-24 bg-brand-gold/10 border-y border-brand-gold/20 relative overflow-hidden" data-id="element-67">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-brand-gold/20 rounded-full blur-[100px] pointer-events-none" data-id="element-68" />

      <div className="container px-4 mx-auto text-center relative z-10 max-w-3xl" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-70">
          <h2 className="mb-4 md:mb-6 text-3xl font-bold md:text-5xl font-serif" data-id="element-71">
            Hacé clic y empezá <span className="text-gradient-gold" data-id="element-72">hoy</span>
          </h2>
          <p className="mb-6 md:mb-8 text-base md:text-xl text-gray-300" data-id="element-73">
            Dejá de publicar contenido que solo genera vistas. Empezá a crear
            contenido que capta atención, genera deseo y convierte seguidores en
            clientes.
          </p>
          <Button href="#pricing" className="text-xl px-10 py-5 shadow-[0_0_40px_-10px_rgba(212,175,55,0.6)]" data-id="element-74">
            Acceder ahora
          </Button>
        </motion.div>
      </div>
    </section>;
};